export default __webpack_public_path__ + "files/media/s-nyas.d77cbc09.jpg";